import { REQUIRED_ROLES } from "./rquired-roles";

export const detailedEvaluationRoutes = {
  path: "/detailed-evaluation",
  name: "detailedEvaluation",
  meta: {
    authorized: true,
    roles: REQUIRED_ROLES['detailed-evaluation']
  },
  component: () => import("@/views/detailed-evaluation/index.vue"),
  children: [
    {
      path: "",
      name: "detailedEvaluationList",
      meta: {
        authorized: true,
        roles: REQUIRED_ROLES['detailed-evaluation']
      },
      component: () => import("@/views/detailed-evaluation/list/index.vue"),
    },
    {
      path: "add",
      name: "detailedEvaluationAdd",
      meta: {
        authorized: true,
        roles: REQUIRED_ROLES['detailed-evaluation']
      },
      component: () =>
        import("@/views/detailed-evaluation/AddEditForm/index.vue"),
    },
    {
      path: "details/:id",
      name: "detailedEvaluationDetails",
      meta: {
        authorized: true,
        roles: REQUIRED_ROLES['detailed-evaluation']
      },
      component: () => import("@/views/detailed-evaluation/details/index.vue"),
    },
    {
      path: "edit/:id",
      name: "detailedEvaluationEdit",
      meta: {
        authorized: true,
        roles: REQUIRED_ROLES['detailed-evaluation']
      },
      component: () =>
        import("@/views/detailed-evaluation/AddEditForm/index.vue"),
    },
  ],
};
